import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import Exit from '../components/Exit/Exit';
import AlertNotification from '../components/AlertNotification/AlertNotification';
import BlockedUserMessage from '../components/common/BlockedUserMessage';
import ProfilePage from '../pages/profile/ProfilePage';

import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary';
import FirstSteps from '../components/Tour/FirstSteps';

const useEmptyEmail = (componentProps) => {
  const profile = useSelector((state) => state.webmaster.profile);

  const { email } = profile;
  const { location } = componentProps;

  if (!email || (email && !email.trim().length)) {
    if (
      location.pathname !== '/profile/edit' &&
      // location.pathname !== '/logout' &&
      !location.pathname.includes('tickets')
    ) {
      componentProps.history.replace('/profile/edit');
      return true;
    }
  }
  return false;
};

export const PrivateRoute = (props) => {
  const { component: Component, ...rest } = props;
  const isAuthenticated = useSelector((state) => state.webmaster.isAuthenticated);

  const renderRoute = (componentProps) => {
    if (isAuthenticated) {
      const noEmail = useEmptyEmail(componentProps);
      return (
        <ErrorBoundary>
          <div id="content">
            <AlertNotification />
            {/* <FirstSteps /> */}
            <BlockedUserMessage />
            {noEmail ? <ProfilePage {...componentProps} /> : <Component {...componentProps} />}
          </div>
        </ErrorBoundary>
      );
    } else {
      return <Exit />;
    }
  };

  return <Route {...rest} component={(props) => renderRoute(props)} />;
};

export default PrivateRoute;
